import React from 'react'
import { MenuItem } from '@material-ui/core'
import { Control, FieldError } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useReactiveVar } from '@apollo/client'
import { ControlledTextField } from '../../../../form/ControlledTextField'
import { HeatingOrCoolingSource } from '../../../../../generated/graphql'
import { validators } from '../../../../../validation/validators'
import { activeVersionVar } from '../../../../../apollo/reactive-vars'

type Props = {
  control: Control
  name: string
  error?: FieldError
  label: string
}

export function StandardHeatingOrCoolingSource({
  control,
  name,
  error,
  label,
}: Props): React.ReactElement {
  const { t } = useTranslation()
  const activeVersion = useReactiveVar(activeVersionVar)

  if (!activeVersion) {
    return <></>
  }

  const availableSources = Object.values(HeatingOrCoolingSource).filter(
    (source) =>
      activeVersion.energyBus
        ? true
        : source !== HeatingOrCoolingSource.EnergyBus,
  )

  return (
    <ControlledTextField
      control={control}
      name={name}
      error={error}
      label={label}
      rules={{ ...validators.required }}
      select
    >
      {availableSources.map((source) => (
        <MenuItem key={source} value={source}>
          {t(`heatingOrCoolingSource.${source}`)}
        </MenuItem>
      ))}
    </ControlledTextField>
  )
}
